import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useParams } from "react-router";
import { getProfileDetails } from "../Actions/EmployerAction";
import { token } from "../Actions/AuthAction";
import { roleid } from "../Actions/AuthAction";
import CONFIG from "../../config";

export const EmployerProfile = () => {
  const history = useHistory();
  const [showEdit, setShowEdit] = useState(false);
  const sampleImage = "../../assets/img/profile128.png";
  const [details, setDetails] = useState([]);
  const uid = useParams().id;
  useEffect(() => {
    getProfileDetails({ key: token(), id: uid != undefined ? uid : "" })
      .then((res) => {
        setDetails(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        // if(err.response.status === 401){
        // 	window.location.reload();
        // }
      });
  }, []);
  const handleClose = () => {
    setShowEdit(false);
  };

  const viewDetail = () => {
    history.push({
      pathname: `/employeradd/0`,
      state: {
        detail: details,
      },
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid my-1">
        <div className="row">
          <div className="col-md-3 col-sm-12 col-xs-12">
            <div className=" profilebox mt-5 pt-5">
              {details.length > 0 && details[0].logo ? (
                <img
                  src={`${CONFIG.IMAGE_URL}/${details[0].logo}`}
                  alt="John"
                  style={{ margin: "auto", width: "50%", borderRadius: "50%" }}
                />
              ) : (
                <img
                  src={sampleImage}
                  alt="John"
                  style={{ margin: "auto", width: "50%", borderRadius: "50%" }}
                />
              )}
              <h2>{details.length > 0 ? details[0].companyname : ""}</h2>
              <p className="title">
                <a
                  href={details.length > 0 ? details[0].companywebsite : ""}
                  target={"_blank"}
                >
                  {details.length > 0 ? details[0].companywebsite : ""}
                </a>
              </p>
              {roleid() == 4 && (
                <>
                  <span
                    onClick={(e) => viewDetail()}
                    class="btn btn-primary-custom mx-5 mb-2"
                    style={{ cursor: "pointer" }}
                  >
                    Edit
                  </span>
                  <Link
                    class="btn btn-secondary-custom mx-2 mb-2"
                    to="/changepassword"
                  >
                    Change Password
                  </Link>
                </>
              )}
              {roleid() == 1 && (
                <>
                  <Link
                    class="btn btn-secondary-custom mx-2 mb-2"
                    to="/employerlist"
                  >
                    Back
                  </Link>
                </>
              )}
            </div>
          </div>
          <div className="col-md-9 col-sm-12 col-xs-12">
            <div className="card rightside">
              <div id="myTabs">
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active py-3"
                    id="home"
                  >
                    <div className="card-header1 ml4">Profile Details</div>
                    <div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <tbody>
                            <tr>
                              <th scope="row">Email</th>
                              <td>:</td>
                              <td>
                                {details.length > 0
                                  ? details[0].user.email
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Phone Number</th>
                              <td>:</td>
                              <td>
                                {details.length > 0
                                  ? details[0].user.phone
                                  : ""}
                              </td>
                            </tr>

                            <tr>
                              <th scope="row">About</th>
                              <td>:</td>

                              <td
                                className="border-0"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    details.length > 0 ? details[0].about : "",
                                }}
                              />
                            </tr>

                            <tr>
                              <th scope="row">Industry</th>
                              <td>:</td>
                              <td>
                                {details.length > 0 &&
                                  details[0].employersectormaps.map((item) => (
                                    <span class="badge badge-pill badge-secondary mx-1">
                                      {item.sector.sectorname}
                                    </span>
                                  ))}
                              </td>
                            </tr>

                            <tr>
                              <th scope="row">Pincode</th>
                              <td>:</td>
                              <td>
                                {details.length > 0 ? details[0].pincode : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Address</th>
                              <td>:</td>
                              <td>
                                {details.length > 0
                                  ? details[0].companyaddress
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">City</th>
                              <td>:</td>
                              <td>
                                {details.length > 0 ? details[0].city.name : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">State</th>
                              <td>:</td>
                              <td>
                                {details.length > 0
                                  ? details[0].state.name
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">SPOC Name</th>
                              <td>:</td>
                              <td>
                                {details.length > 0 ? details[0].spocname : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">SPOC Email</th>
                              <td>:</td>
                              <td>
                                {details.length > 0 ? details[0].spocemail : ""}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">SPOC Phone Number</th>
                              <td>:</td>
                              <td>
                                {details.length > 0
                                  ? details[0].spocphoneno
                                  : ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
